import Glide, {
	Anchors,
	Autoplay,
	Breakpoints,
	Controls,
	Images,
	Keyboard,
	Swipe
} from '@glidejs/glide/dist/glide.modular.esm.js';


/**
 * @see https://glidejs.com/docs/options/
 */
const setupSlideshows = () =>
{
	const glideContainers = document.querySelectorAll( '.slideshow.glide' );

	glideContainers.forEach( glideContainer =>
	{
		if (glideContainer instanceof HTMLElement) {

			const slides = glideContainer.querySelectorAll( '.glide__slide' );

			if (slides.length <= 1) {
				return;
			}

			const autoplayAttr      = glideContainer.dataset.autoplay;
			const perViewAttr       = glideContainer.dataset.perView;
			const modalIdAttr       = glideContainer.dataset.modalId;
			const doFade            = glideContainer.hasAttribute( 'data-fade' );
			const pauseOnHover      = glideContainer.dataset.pauseOnHover === 'true';
			const perView           = perViewAttr !== undefined ? parseInt( perViewAttr, 10 ) : 1;
			const gap               = perView === 1 ? 0 : 20;
			const animationDuration = doFade ? 1 : 600;
			let autoplay: any       = false;
			let doMount             = true;

			if (autoplayAttr !== undefined && autoplayAttr !== 'false') {
				autoplay = autoplayAttr === '' || autoplayAttr === 'true' ? 4000 : parseInt( autoplayAttr, 10 )
			}

			const glide = new Glide( glideContainer, {
				type:              'carousel',
				perView:           perView,
				autoplay:          autoplay,
				gap:               gap,
				animationDuration: animationDuration,
				hoverpause:        pauseOnHover,
			} );

			// if slideshow is in a bootstrap modal, delay initialization until the modal has been opened - otherwise slide width will be zero.

			if (modalIdAttr) {

				const modal = document.querySelector( '#' + modalIdAttr );

				if (modal instanceof Element) {

					doMount = false;
					modal.addEventListener( 'shown.bs.modal', () => glide.mount() );
					modal.addEventListener( 'hide.bs.modal', () => glide.destroy() );
				}
			}

			if (doMount) {
				glide.mount( { Anchors, Autoplay, Breakpoints, Controls, Images, Keyboard, Swipe } );
				glideContainer.classList.add( 'slideshow-mounted' );
			}
		}
	} );
};


/**
 *
 */
export default setupSlideshows;